import { Avatar, Card, CardBody } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router';

export function MetricTrackerList({ metrics }) {
  return (
    <div className="space-y-4">
      {metrics.map((metric) => (
        <Metric metric={metric} key={metric.id} />
      ))}
    </div>
  );
}

function Metric({ metric }) {
  const navigate = useNavigate();

  return (
    <Card
      isPressable
      onPress={() => navigate(`/progress/metrics/${metric.id}`)}
      className="bg-primary-100 w-full"
      shadow="sm"
    >
      <CardBody>
        <div className="flex justify-between">
          <div className="flex gap-4 items-center">
            <Avatar
              color="primary"
              icon={
                <Icon
                  icon="healthicons:cardiogram-e-outline"
                  className="text-3xl"
                />
              }
            />
            <h2>{metric.patientDisplayName}</h2>
          </div>
          <Icon
            icon="mdi:chevron-right"
            className="text-xl place-self-center"
          />
        </div>
      </CardBody>
    </Card>
  );
}
